import { render, staticRenderFns } from "./output_workbench.vue?vue&type=template&id=18f6af88&scoped=true"
import script from "./output_workbench.vue?vue&type=script&lang=js"
export * from "./output_workbench.vue?vue&type=script&lang=js"
import style0 from "./output_workbench.vue?vue&type=style&index=0&id=18f6af88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6af88",
  null
  
)

export default component.exports